import React, { Fragment, memo, useCallback, useContext, useEffect, useState } from 'react'

import BreadCrumb from '../../components/Layout/BreadCrumb'
import Container from '../../components/HOC/Container'
import { Footer } from '../../components/Layout/Footer'
import { Header } from '../../components/Layout/Header'
import { Icon, PageNotification } from '../../components/common'
import { LanguageContext } from '../../context/LanguageContext'
import { SideDrawer } from '../../components/Layout/SideDrawer'
import SideMenu from '../../components/HOC/SideMenu'
import { util } from '../../util'
import { Outlet } from 'react-router-dom'

const Layout = ({
    pathname,
    // children,
    user_details,
    logout,
    pageNotifications,
    adp_configurations,
    has_adp_configurations_failed,
    fetchADPConfigurations,
}) => {
    useEffect(() => {
        if (has_adp_configurations_failed) {
            return
        }
        if (
            !adp_configurations ||
            !adp_configurations.feature_flag ||
            !adp_configurations.feature_flag.length
        ) {
            fetchADPConfigurations()
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [adp_configurations, has_adp_configurations_failed])

    const [open, setOpen] = useState(false)

    /**
     * Toggles the hamburger menu and side menu bar.
     */
    const toggleSideMenu = () => setOpen(!open)

    /**
     * toggleBackdrop Controls the backdrop when the side menu is opened.
     */
    const toggleBackdrop = useCallback(() => setOpen(false), [])

    //RtL Support
    const { rtl } = useContext(LanguageContext)

    return (
        <Fragment>
            <Header
                open={open}
                toggleHandler={toggleSideMenu}
                user_details={user_details}
                logout={logout}
            />
            <BreadCrumb paths={pathname} />
            <SideMenu
                showBackdrop={false}
                open={open}
                toggleMenu={toggleBackdrop}
                direction={rtl ? 'right' : 'left'}
                width={'sm'}
                position={`fix-${rtl ? 'right' : 'left'}`}
            >
                <>
                    <Icon
                        className={'mt-6 ml-6'}
                        size={'md'}
                        pointer={true}
                        onClick={toggleSideMenu}
                        renderIcon={util.CloseIcon}
                    />

                    <SideDrawer toggleSideMenu={toggleSideMenu} />
                </>
            </SideMenu>
            {/** pageNotifications object should follow PageNotification PropTypes (Please check the component for prop types) */}
            <PageNotification show={!!pageNotifications} {...pageNotifications} />

            {/** Container is a wrapper around the page */}
            <Container>
                <Outlet />
            </Container>
            <Footer />
        </Fragment>
    )
}

export default memo(Layout)
